import React, { Component } from 'react';
import SocialItemComponent from './social.item.component';
class SocialComponent extends Component {
    render() {
        return (
            <ul className="socialMedia animated tada">
                <SocialItemComponent className="github" title="GitHub" url="http://github.com/AminTaghikhani"/>
                <SocialItemComponent className="linkedin" title="linkedIn" url="http://www.linkedin.com/in/amintaghikhani"/>
            </ul>
        );
    }
}

export default SocialComponent;



// WEBPACK FOOTER //
// ./src/components/hello/socialMedia/social.component.jsx